import { Component, OnInit, SecurityContext } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { TermsService } from '@client/app/modules/terms/terms.service';
import { privacy_terms } from '@monsido/core/constants/general.constant';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

declare global {
    interface Window {
        privacy_terms: string;
    }
}

@Component({
    selector: 'privacy-dialog',
    templateUrl: './privacy-dialog.component.html',
    styleUrls: ['./privacy-dialog.component.scss'],
    standalone: false,
})
export class PrivacyDialogComponent implements OnInit {
    modalRef: NgbModalRef | null = null;
    terms = '';
    accept = false;
    saving = false;
    version: string = '';

    constructor (
        private modalService: NgbActiveModal,
        private sanitizer: DomSanitizer,
        private monEventService: MonEventService,
        private termsService: TermsService,
    ) {}

    ngOnInit (): void {
        this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-show' });
        this.terms = this.sanitizer.sanitize(SecurityContext.HTML, privacy_terms) ?? '';
    }

    submit (): void {
        if (!this.accept || this.saving) {
            return;
        }

        this.saving = true;
        this.termsService.accept(this.version)
            .then(() => {
                this.monEventService.run('actionTrigger', { action: 'accept-terms-dialog-accepted' });
                this.close();
            })
            .catch(() => {
                // The global error interceptor shows the error; keep the dialog open so the user can retry
            })
            .finally(() => {
                this.saving = false;
            });
    }

    close (): void {
        if (this.modalService) {
            this.modalService.close();
        }
    }
}
